import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {ApprovalModel} from '../../shared/dto/approval.model';
import Swal, {default as swal} from 'sweetalert2';
import {ApprovalService} from '../../service/approval.service';
import {Router} from '@angular/router';
import {UserRoleEnum} from '../../shared/enums/user-role.enum';
import {ChecklistEnum} from '../../shared/enums/checklist.enum';
import {ChecklistService} from '../../service/checklist.service';
import {TokenStorageService} from '../../shared/service/token-storage.service';
import {ChecklistModel} from '../../shared/dto/checklist.model';

@Component({
  selector: 'app-remark',
  templateUrl: './remark.component.html',
  styleUrls: ['./remark.component.scss']
})
export class RemarkComponent implements OnInit {
  remarkForm: FormGroup;
  @Input() fromParent;
  approvalModel: ApprovalModel = new ApprovalModel();
  isError: boolean = false;
  isSucess: boolean = false;
  isValid: boolean = false;

  public checklistType: string;
  public checklistId: number[]=[];
  public isValidChecklist = true;
  public checklist: ChecklistModel[];
  applicantType:string;

  constructor(private approvalService: ApprovalService,
              private router: Router,
              private checklistService: ChecklistService,
              private tokenStorageService: TokenStorageService) { }

  ngOnInit() {
    this.approvalModel = this.fromParent.model;
    this.applicantType = this.fromParent.appType;
    this.remarkForm = new FormGroup({
      remark: new FormControl(null),
    });

    this.getChecklist('reject');
  }

  submitRequest() {
    this.approvalModel.remark = this.remarkForm.value.remark;

    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to reject the request?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        this.approvalService.rejectRequest(this.approvalModel).subscribe(
          (success: string) => {
            // this.isSucess = true;
            swal.fire('Success', 'Applicant Details Updated', 'success');
            this.router.navigate(['/dashboard/approval-pending', this.applicantType] );
            this.approvalService.close();
          },
          (error) => {
            swal.fire('Error', 'Error When Updating the Request', 'error');
          },
        );
      } else {
      }
    });
  }

  getChecklist(checkListType:String) {

    if(checkListType == 'approval'){
      if(this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.EXM) {
        this.checklistType = ChecklistEnum.APPROVAL_EXM;
      }

      if(this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.SHO) {
        this.checklistType = ChecklistEnum.APPROVAL_SHO;
      }

      if(this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.DG) {
        this.checklistType = ChecklistEnum.APPROVAL_DG;
      }
    }

    if(checkListType == 'reject'){
      if(this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.EXM) {
        this.checklistType = ChecklistEnum.REJECT_EXM;
      }

      if(this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.SHO) {
        this.checklistType = ChecklistEnum.REJECT_SHO;
      }

      if(this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.DG) {
        this.checklistType = ChecklistEnum.REJECT_DG;
      }
    }

    if(checkListType == 'return'){
      if(this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.EXM) {
        this.checklistType = ChecklistEnum.RETURN_EXM;
      }

      if(this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.SHO) {
        this.checklistType = ChecklistEnum.RETURN_SHO;
      }

      if(this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.DG) {
        this.checklistType = ChecklistEnum.RETURN_DG;
      }
    }

    this.checklistService.getChecklistByType(this.checklistType).subscribe(
      (result: any ) => {
        this.checklist = result;
        if(this.checklist.length > 0) {
          this.checklist.forEach(item => {
            this.checklistId.push(item.id);
          });
          this.isValidChecklist = true;
        }else{
          this.isValidChecklist = false;
        }
      }
    );
  }


}
